import withPaginator from "./withPaginator";
import Paginator from "./paginator";
export default (paginatorInfo)=>withPaginator(Paginator, paginatorInfo);